import { ActivityDataTargetSchema } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

import { z } from 'zod'

export const ProjectCompletedActivityDetailsSchema = ActivityTypeAndDataSchema(
  'project_completed',
  z.object({
    project: ActivityDataTargetSchema,
  })
)
